import Vue from 'vue'

Vue.mixin({
  data: function () {
    return {
      mobile: false,
      app: false
    }
  },
  mounted: function () {
    var vm = this

    vm.$nextTick(function () {
      vm.mobile = $(window).width() <= 992

      var userAgent = navigator.userAgent
      var rules = ['WebView', '(iPhone|iPod|iPad)(?!.*Safari/)', 'Android.*(wv|.0.0.0)']
      var regex = new RegExp(`(${rules.join('|')})`, 'ig')
      vm.app = Boolean(userAgent.match(regex))
    })

    vm.$enquire.register('screen and (min-width:992px)', {
      match: function () {
        vm.mobile = false
      },
      unmatch: function () {
        vm.mobile = true
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/mixins/mobile-detect.js